// extracted by mini-css-extract-plugin
module.exports = {"Page":"EditChildExtraBedPolicy_Page__qh99a"};